<template>
  <ModalDialog
    header-text="New Visit Form"
    contentClass="visit-modal-content"
    :canBeClosed="!formSubmitting"
    @closeModal="closeModal"
    open
  >
    <template v-slot:content>
      <NewVisitForm
        @closeForm="onFormClosed"
        @submittingChanged="(value: boolean) => (formSubmitting = value)"
      />
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";
import { ref } from "vue";
import { useNotificationStore } from "@/stores/useNotificationStore";
import { NotificationTypeEnum } from "@/Domain/NotificationTypeEnum";
import NewVisitForm from "./NewVisitForm.vue";

const notificationStore = useNotificationStore();

const emit = defineEmits<{
  (e: "closeModal"): void;
}>();

const formSubmitting = ref(false);

const onFormClosed = () => {
  emit("closeModal");
};

const closeModal = function (closed: boolean) {
  if (formSubmitting.value || !closed) {
    notificationStore.notify({
      type: NotificationTypeEnum.info,
      message: "Please wait while visit is being created",
      duration: 5000,
    });
    return;
  }
  emit("closeModal");
};
</script>

<style lang="scss">
.visit-modal-content {
  width: auto;
  max-width: 600px;
  padding: 2rem;
  margin: 0 -20px;

  @include media-breakpoint-up(sm) {
    width: 500px;
  }

  @include media-breakpoint-up(md) {
    width: 600px;
  }
}
</style>
